import type { NDateLocale, NLocale } from "naive-ui"
import type { WritableComputedRef } from "vue"
import type { LocaleCodes } from "@/lang/config"
// TODO-NEXT: MVP2 enable english locale
import { /* dateEnUS, */ dateItIT, /* enUS, */ itIT } from "naive-ui"
import { acceptHMRUpdate, defineStore } from "pinia"
import { nextTick } from "vue"
import { useI18n } from "vue-i18n"
import dayjs from "@/utils/dayjs"

export const useLocalesStore = defineStore("i18n", {
	state: () => {
		nextTick(() => {
			dayjs.locale(useLocalesStore().locale)
		})

		return {
			locale: useI18n().locale as WritableComputedRef<LocaleCodes, string>,
			availableLocales: useI18n().availableLocales as LocaleCodes[]
		}
	},
	actions: {
		setLocale(locale: LocaleCodes): LocaleCodes {
			dayjs.locale(locale)
			this.locale = locale
			return locale
		}
	},
	getters: {
		naiveuiLocales(): { code: LocaleCodes; ui: NLocale; date: NDateLocale }[] {
			return [
				// TODO-NEXT: MVP2 enable english locale
				// { code: "en", ui: enUS, date: dateEnUS },
				{ code: "it", ui: itIT, date: dateItIT }
			]
		},
		naiveuiLocale(state): NLocale | undefined {
			return this.naiveuiLocales.find(locale => locale.code === state.locale)?.ui
		},
		naiveuiDateLocale(state): NDateLocale | undefined {
			return this.naiveuiLocales.find(locale => locale.code === state.locale)?.date
		}
	},
	persist: {
		// @ts-expect-error "Type instantiation is excessively deep and possibly infinite" ts(2589)
		pick: ["locale"]
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useLocalesStore, import.meta.hot))
}
